/**
 * Creditors Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const creditorsAPI = {
  getAll: (params) => apiClient.get('/creditors', { params }),
  getById: (id) => apiClient.get(`/creditors/${id}`),
  getLiabilities: (id, params) => apiClient.get(`/creditors/${id}/liabilities`, { params }),
  create: (data) => apiClient.post('/creditors', data),
  update: (id, data) => apiClient.put(`/creditors/${id}`, data),
  delete: (id) => apiClient.delete(`/creditors/${id}`),
};

export default creditorsAPI;

